import { render, staticRenderFns } from "./QAApplications.vue?vue&type=template&id=0891697d"
import script from "./QAApplications.vue?vue&type=script&lang=js"
export * from "./QAApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports